export const TOAST_MARKET_ICON_CLASSNAME = 'w-auto h-4 sm:h-6';
